import React from 'react';
import { Star, GraduationCap, Award } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section className="py-20 px-6 dark-section">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Expert Educators & Advisors
          </h2>
          <div className="section-underline"></div>
          <p className="text-xl text-gray-300">
            Learn from experienced professionals committed to your success
          </p>
        </div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              {/* Avatar and Name */}
              <div className="flex items-start gap-4 mb-6">
                <div className={`w-20 h-20 rounded-2xl ${testimonial.color} flex items-center justify-center text-white text-xl font-bold flex-shrink-0 shadow-lg`}>
                  {testimonial.initial}
                </div>
                <div className="flex-1">
                  <div className="font-bold text-white text-xl mb-1">
                    {testimonial.name}
                  </div>
                  <div className="text-cyan-400 text-sm font-semibold mb-2">
                    {testimonial.role}
                  </div>
                  {/* Stars */}
                  <div className="flex gap-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} size={16} className="fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                </div>
              </div>

              {/* Quote */}
              <p className="text-gray-300 leading-relaxed mb-6">
                "{testimonial.quote}"
              </p>

              {/* Credentials */}
              {testimonial.credentials && (
                <div className="pt-4 border-t border-gray-700">
                  <div className="flex items-start gap-2 text-gray-400 text-sm">
                    <Award size={16} className="text-cyan-400 mt-1 flex-shrink-0" />
                    <span>{testimonial.credentials}</span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-cyan-500/20 to-purple-500/20 rounded-2xl border border-cyan-400/30">
            <GraduationCap className="text-cyan-400" size={32} />
            <div className="text-left">
              <div className="text-white font-bold text-lg">Learn from the Best</div>
              <div className="text-gray-300 text-sm">Expert guidance every step of your journey</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;